import { render, staticRenderFns } from "./cmpconteudoalertacliente.vue?vue&type=template&id=4e9b9fc0&"
import script from "./cmpconteudoalertacliente.vue?vue&type=script&lang=js&"
export * from "./cmpconteudoalertacliente.vue?vue&type=script&lang=js&"
import style0 from "./cmpconteudoalertacliente.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports